// types used for Listing the views (Currently used for photos).
export enum LayoutStyle {
  Grid = 'grid',
  List = 'list',
  Carousel = 'carousel'
}
